import { format, addDays, getDay, startOfMonth } from "date-fns";
import { ptBR } from "date-fns/locale";

function parseLocalDateString(dateString) {
  const [year, month, day] = dateString.split("-");
  return new Date(year, month - 1, day);
}

export const generateDates = (numDays, selectedMonth) => {
  const dates = [];
  let today = new Date();
  let startDate;

  if (selectedMonth === today.getMonth()) {
    startDate = today; // Começa a partir de hoje no mês atual
  } else {
    startDate = startOfMonth(new Date(today.getFullYear(), selectedMonth, 1)); // Primeiro dia do mês escolhido
  }

  while (dates.length < numDays) {
    const dayOfWeek = getDay(startDate);
    if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Pula domingos (0) e sábados (6)
      dates.push({
        day: format(startDate, "dd", { locale: ptBR }),
        weekDay: format(startDate, "EEE", { locale: ptBR }).slice(0, 3).toUpperCase(),
        date: format(startDate, "yyyy-MM-dd", { locale: ptBR }),
      });
    }
    startDate = addDays(startDate, 1);
  }

  return dates;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getMonthName = (dateString) => {
  if (!dateString) return "";
  const dateObj = parseLocalDateString(dateString);
  const monthName = format(dateObj, "MMMM", { locale: ptBR });
  return capitalizeFirstLetter(monthName);
};